import { NotificationIdentifier } from '@evorait/pace-core';
import { createAction, props } from '@ngrx/store';
import { FormIdentifier } from '../../types/form-identifier';
import { FormsConstants } from '../../types/forms-constants';

export const loadSafetyAssessmentForm = createAction(
    '[Forms] Load Safety Assessment Form',
    props<{
        form: FormIdentifier;
        notification: NotificationIdentifier;
        status: FormsConstants.FORMSTATUS;
    }>(),
);

export const cleanupSafetyAssessmentForm = createAction(
    '[Forms] Cleanup Safety Assessment Form',
    props<{
        form: FormIdentifier;
        notification: NotificationIdentifier;
    }>(),
);
